import React from "react";
import { Field, FieldArray } from "formik";

import { Input } from "../../../../../components/formik";
import { Col, Row } from "reactstrap";
import { withError } from "../../../../../components/hocs";

const ErrorInput = withError(Input);

const LegalEntityFormFields = ({ countries }) => (
  <React.Fragment>
    <Row className="mt-4">
      <Col lg={5} >
        <Field
          placeholder="Company name"
          name="name.fullName"
          component={ErrorInput}
        />
      </Col>
      <Col lg={7} className="p-0">
        <Row>
          <Col lg={6} className="pr-0">
            <Field
              placeholder="City"
              name="addresses[0].city"
              component={Input}
            />
          </Col>
          <Col lg={6} >
            <Field
              placeholder="Post code"
              name="addresses[0].postalCode"
              component={Input}
            />
          </Col>
        </Row>
      </Col>
    </Row>
    <Row className="mt-4">
      <Col lg={5}>
        <Field
          placeholder="Street and number"
          name="addresses[0].streetNumber"
          component={Input}
        />
      </Col>
      <Col lg={7}>
        <FieldArray name="addresses">
          <Field
            placeholder="Headquaters and Management Address"
            name="addresses[0].headquaters"
            component={Input}
          />
        </FieldArray>
      </Col>
    </Row>
    <Row className="mt-4">
      <Col lg={12}>
        <Field
          type="textarea"
          placeholder="Comment"
          name="comment"
          component={ErrorInput}
        />
      </Col>
    </Row>
  </React.Fragment>
);

export default LegalEntityFormFields;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/components/upsert-watch-list-entry-form/legal-entity-form-fields/LegalEntityFormFields.jsx